/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Program } from '../../models/program';

export interface FindOneAdminProgram$Params {
  id: string;
}

export function findOneAdminProgram(
  http: HttpClient,
  rootUrl: string,
  params: FindOneAdminProgram$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Program>> {
  const rb = new RequestBuilder(rootUrl, findOneAdminProgram.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Program>;
    })
  );
}

findOneAdminProgram.PATH = '/admin/programs/{id}';
